export default "__VITE_ASSET__41ff9a6d__"